export const ON_PESQUISAR_STATUS_OPERACAO = 'ON_PESQUISAR_STATUS_OPERACAO'

const DashboardActions = {
  onPesquisarStatusOperacao(pInicial, pFinal, status) {
    return {
      type: ON_PESQUISAR_STATUS_OPERACAO,
      payload: { pInicial, pFinal, status },
    }
  },
}

export default DashboardActions
